import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import ProListings from "./components/ProListings";
import ReviewsSection from "./components/ReviewsSection";
import FAQSection from "./components/FAQSection";
import ContentGuide from "./components/ContentGuide";
import ServiceAreaLinks from "./components/ServiceAreaLinks";
import LeadForm from "./components/LeadForm";

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <SiteNavbar />
      <main>
        <Hero />
        <HowItWorks />
        <ProListings />
        <ReviewsSection />
        <FAQSection />
        <ContentGuide />
        <LeadForm />
        <ServiceAreaLinks />
      </main>
      <SiteFooter />
    </div>
  );
}
